import styles from './AbsencesFooterContent.module.scss';

interface Props {
  note?: string;
  description?: string;
}

const AbsencesFooterContent: React.FC<Props> = ({ note, description }) => (
  <div className={styles.wrapper} data-testid="footerContent">
    {note && <div className={styles.note}>{note}</div>}
    {description && <div className={styles.description}>{description}</div>}
  </div>
);

export default AbsencesFooterContent;
